import { create } from 'zustand';
const useMarketConfig = create((set) => ({
    marketConfig: null,
    setMarketConfig: (marketConfig) => {
        set({ marketConfig });
    },
}));
export default useMarketConfig;
